import User from "../entities/getUser";
import { OnboardingRepository } from "../repositories/OnboardingRepository";

export class GetUser {
	constructor(private repository: OnboardingRepository) {}
	execute(): Promise<User> {
		return this.repository.getUser();
	}
}
